<template>
  <div :menu-fix="true">
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.agentChecks'), $t('text.list')]">
        <el-dropdown menu-align="start" trigger="click" class="mgl10">
          <el-button type="default" size="mini">
            {{ $t("action.importCheck") }}
            <i class="el-icon-caret-bottom el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="courierTenant of courierTenants"
              :key="courierTenant.courier.id"
            >
              <div
                @click="
                  $router.push(
                    '/fnReport/fn-reports/deliver-checks/agents/import/' +
                      courierTenant.courier.id +
                      '?name=' +
                      courierTenant.courier.name
                  )
                "
              >
                {{ courierTenant.courier.name }}
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </breadcrumb>
    </div>
    <div class="search">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            v-model.trim="searchForm.title"
            :placeholder="$t('settlement.title')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="searchForm.clientId"
            size="small"
            filterable
            clearable
            :placeholder="$t('menu.couriers')"
          >
            <el-option
              v-for="courierTenant in courierTenants"
              :key="courierTenant.courierId"
              :label="courierTenant.courier.name"
              :value="courierTenant.courierId"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <vxe-table
        :data="records"
        :loading="loading"
        id="recordsTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="title"
          :title="$t('settlement.title')"
          min-width="140"
        >
          <template v-slot="{ row }">
            <span class="blue" @click="showRow(row)">{{ row.title }}</span>
            <div
              class="font10 blue"
              @click="
                $router.push(
                  '/fnReport/fn-reports/deliver-checks/agents/line-item/' +
                    row.id +
                    '?name=' +
                    row.title
                )
              "
            >
              {{ $t("text.settlementLineItem") }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="courierName"
          :title="$t('menu.couriers')"
          min-width="80"
        />

        <vxe-table-column field="finishAt" :title="'导入情况'" min-width="80">
          <template v-slot="{ row }">
            <span v-if="row.finishAt == null">
              <i class="el-icon-loading"></i>
            </span>
            <span v-else>导入已完成</span>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="quantity"
          :title="$t('deliverCheck.quantity')"
          min-width="80"
        />
        <vxe-table-column field="successQuantity" min-width="80">
          <template #header>
            <span
              >{{ $t("deliverCheck.successQuantity") }}
              <el-popover placement="top-start" width="300" trigger="hover">
                <div class="mgb10 font8">1、单号能匹配上</div>
                <div class="mgb10 font8">
                  2、当前单号的发货费用和导入费用相同
                </div>
                <div class="mgb10 font8">
                  3、当前单号的发货重量和导入重量相同
                </div>
                <i class="el-icon-question" slot="reference"></i>
              </el-popover>
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="warnQuantity"
          :title="$t('deliverCheck.warnQuantity')"
          min-width="80"
        >
          <template #header>
            <span
              >{{ $t("deliverCheck.warnQuantity") }}
              <el-popover placement="top-start" width="300" trigger="hover">
                <div class="mgb10 font8">1、单号能匹配上</div>
                <div class="mgb10 font8">
                  2、当前单号的发货费用和导入费用不相同 或者
                  当前单号的发货重量和导入重量不相同
                </div>
                <i class="el-icon-question" slot="reference"></i>
              </el-popover>
            </span>
          </template>
          <template v-slot="{ row }">
            <span :class="row.warnQuantity != 0 ? 'orange' : ''">
              {{ row.warnQuantity }}
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="failQuantity"
          :title="$t('deliverCheck.failQuantity')"
          min-width="80"
        >
          <template #header>
            <span
              >{{ $t("deliverCheck.failQuantity") }}
              <el-popover placement="top-start" width="300" trigger="hover">
                <div class="mgb10 font8">
                  1、单号能匹配不上 或者 单号匹配多条发货单
                </div>
                <i class="el-icon-question" slot="reference"></i>
              </el-popover>
            </span>
          </template>
          <template v-slot="{ row }">
            <span :class="row.failQuantity != 0 ? 'red' : ''">
              {{ row.failQuantity }}
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="createAt"
          :title="$t('text.createAt')"
          min-width="110"
        >
          <template v-slot="{ row }">
            {{ row.userName }}
            <div class="fony10">{{ row.createAt }}</div>
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column
          field="verifyAt"
          :title="$t('settlement.verifyAt')"
          min-width="110"
        >
          <template v-slot="{ row }">
            {{ row.verifyName }}
            <div class="fony10">{{ row.verifyName }}</div>
          </template>
        </vxe-table-column> -->
        <vxe-table-column field="action" :title="$t('text.action')" width="100">
          <template v-slot="{ row, rowIndex }">
            <el-button
              v-if="row.verifyAt == null"
              type="text"
              size="mini"
              @click="edit(row, rowIndex)"
              >{{ $t("text.edit") }}</el-button
            >
            <el-button
              v-if="row.verifyAt == null"
              type="text"
              size="mini"
              @click="deleteRow(row)"
              >{{ $t("text.delete") }}</el-button
            >
          </template>
        </vxe-table-column>
      </vxe-table>

      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span>
          条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
    <drawer
      :title="$t('text.view')"
      :visible.sync="showDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show :id="currentRowId" />
    </drawer>

    <!-- 编辑 -->
    <el-dialog
      :title="$t('rules.edit', [$t('settlement.title')])"
      :visible.sync="editDF"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form ref="editObjForm" :model="editObj" label-width="60px">
        <el-form-item
          :label="$t('settlement.title')"
          :prop="'title'"
          :rules="[
            { required: true, validator: validateTitleEdit, trigger: 'blur' },
          ]"
        >
          <el-input size="small" v-model.trim="editObj.title" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editDoing"
          size="small"
          @click="editSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { page, table } from "@/utils/mixins.js";
import Show from "./show";
import MCourierCost from "@/api/mCourierCost.js";
import Courier from "@/api/courier.js";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    Show,
  },
  data() {
    var validateTitleEdit = (rule, value, callback) => {
      const self = this;
      if (value == null || value === "") {
        callback(
          new Error(self.$t("rules.required", [self.$t("settlement.title")]))
        );
        return;
      }
      MCourierCost.findByTitle({ title: value }).then(function (res) {
        if (res.data.code === 200 && res.data.entity.id !== self.editObj.id) {
          callback(
            new Error(self.$t("rules.exist", [self.$t("settlement.title")]))
          );
          return;
        } else {
          callback();
        }
      });
    };
    return {
      searchForm: {
        title: null,
        clientId: null,
      },
      sorter: {
        sortBy: "mCourierCost_id",
        sortIndicator: "desc",
      },
      courierTenants: [],
      //
      currentRowIdx: null,
      currentRowId: null,
      showDF: false,
      row: null,
      // 编辑
      validateTitleEdit: validateTitleEdit,
      editDF: false,
      editObj: {
        title: null,
      },
      editDoing: false,
    };
  },
  computed: {
    implicit() {
      return {
        type: "agent",
      };
    },
  },

  created() {
    const self = this;
    Courier.findCourierTenantByTenantId().then(function (res) {
      if (res.status === 200) {
        self.courierTenants = res.data;
      } else {
        self.sysError();
      }
    });
  },
  methods: {
    // // 收款完毕
    // confirmPayOff(row, rowIndex) {
    //   const self = this;
    //   if (confirm(this.$t("action.paymentOff"))) {
    //     DeliverySettlement.payOff(row.id).then(function (res) {
    //       if (res.status === 200) {
    //         self.$message({
    //           message: self.$t("action.paymentOff"),
    //           type: "success",
    //         });
    //         self.records[rowIndex].payoffAt = Util.formatDate(new Date());
    //       } else {
    //         self.sysError();
    //       }
    //     });
    //   }
    // },
    // 删除
    deleteRow(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        MCourierCost.delete(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.loadData();
          } else {
            self.sysError();
          }
        });
      }
    },
    // 编辑
    edit(row, rowIndex) {
      const self = this;
      self.row = row;
      self.currentRowIdx = rowIndex;
      self.editObj.title = row.title;
      self.editDoing = false;
      self.editDF = true;
    },
    editSubmit() {
      const self = this;
      self.$refs.editObjForm.validate((valid) => {
        if (valid) {
          self.editDoing = true;
          MCourierCost.update(this.row.id, self.editObj).then(function (res) {
            self.editDoing = false;
            self.editDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.records[self.currentRowIdx].title = self.editObj.title;
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    showRow(row) {
      this.currentRowId = row.id;
      this.showDF = true;
    },
    //-----
    dataProvider(params) {
      return MCourierCost.search(params);
    },
  },
};
</script>
